<template>
  <!-- 필터없이 간단하게 사용하려는 경우 해당 테이블 컴포넌트 사용 -->
  <div class="box">
    <div class="flex space-between" style="padding-bottom:20px" v-if="filtered.cur_page">
      <div class="flex align-center">
        <span>검색결과 {{ filteredCount }} 개</span>
        <!--
         <span style="color:#ccc"> / </span> 전체</span><span> {{ allCount }}</span><span>개</span>
        -->
      </div>
      <div class="flex-align">
        <div class="flex-align" style="margin-right:8px">
          <toggle-button @change="e=>enableDragScroll = e.value"
                         :value="enableDragScroll"
                         :sync="true"
                         class="changed-font"
                         :width="50"
                         :height="24"></toggle-button>
          <span style="margin-left:4px">좌우로 스와이프</span>
          <i class="material-icons" style="font-size:17px;margin-left:2px">open_with</i>
        </div>
        <!-- 10개씩보기 -->
        <div class="control">
          <span class="select">
            <select v-model="page_length" @change="selPageLength">
              <option v-for="(it,idx) in pageLengthList" :key="'list-'+idx"
                      :value="it.value">{{ it.label }}</option>
            </select>
          </span>
        </div>
      </div>
    </div>
    <scroll-table-wrapper :enableDragScroll="enableDragScroll">
      <!-- 테이블 -->
      <table class="table" style="table-layout: fixed">
        <thead>
        <tr>
          <th v-for="field in field_list" :key="field.eng_name"
              :style="'width:'+field.width">
            <!--<span v-if="field.eng_name==='checkspot'"></span>-->
            <lp-ordering
              v-if="field.eng_name!=='checkspot'"
              :data="field"
              @onSelect="res => $emit('ordering', res)">
              <span style="display:inline-block"
                    v-if="field.eng_name!=='checkspot'">{{ field.ko_name }}</span>
            </lp-ordering>
            <img src="/static/image/checked.png" style="width: 16px; height: 16px" v-else-if="field.eng_name==='checkspot'">
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, trIdx) in items" :key="`trIdx-${trIdx}`">
          <td v-for="(field, idx) in field_list" :key="`field-${idx}`">
            <slot :name="field.eng_name" :item="item" :idx="trIdx"></slot>

            <div style="text-align: center;display: inline-block"
                 :style="imgField(item[field.eng_name])"
                 v-if="field.eng_name==='img'"></div>

            <div style="text-align: center;display: inline-block"
                 :style="imgField(item[field.eng_name][0])"
                 v-else-if="field.eng_name==='imgs'"></div>

            <div v-else-if="field.eng_name==='content1' ||
                      field.eng_name==='content2' ||
                      field.eng_name==='content3'">
              <span>
                <i class="material-icons unselect"
                   v-if="checkContent(field.eng_name, item)==='file'" @click="openModalFile(field.eng_name, item, 'file')">cloud_download</i>
                <i class="material-icons unselect"
                   v-else-if="checkContent(field.eng_name, item)==='img'" @click="openModalFile(field.eng_name, item, 'img')">portrait</i>
                <span v-else-if="checkContent(field.eng_name, item)==='text'">{{item[field.eng_name]}}</span>
              </span>
            </div>

            <!-- 회원등급 목록 페이지의 label_type일경우 -->
            <div v-else-if="field.eng_name==='label_type' && item['name']">
                <span :style="labelStyle(item['label_type'], item)">
                  <i class="material-icons" style="vertical-align: middle" v-if="item['label_type']===2">person_outline</i>
                  {{item['name']}}</span>
            </div>


            <span v-if="$scopedSlots[field.eng_name] === undefined &&
                    field.eng_name!=='img' &&
                    field.eng_name!=='imgs' &&
                    field.eng_name!=='content1' &&
                    field.eng_name!=='content2' &&
                    field.eng_name!=='content3' &&
                    field.eng_name!=='label_type'">{{item[field.eng_name]}}</span>

          </td>
        </tr>
        </tbody>
      </table>
    </scroll-table-wrapper>

    <!-- 선택승인, 선택 미승인 같은 post요청을 하는 경우 -->
    <div>
      <slot name="spot"></slot>
    </div>

    <!-- 페이지 -->
    <div class="pagination-group" v-if="filtered.total_page">
      <div class="pagination-btn-prev" @click="prevPage">
        <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
      </div>
      <div class="pagination-num" v-for="(n,idx) in calcPageList" :key="'page-'+idx">
        <span
          class="unselect"
          :class="{
            'pagination-num-selected': n === filtered.page_num,
            'pagination-num-not-selected': n !== filtered.page_num,
          }"
          @click="changePage(n)"
          style="font-size:1.2rem">{{ n }}</span>
      </div>
      <div class="pagination-btn-next" @click="nextPage">
        <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
      </div>
    </div>
  </div>
</template>

<script>
  import LpOrdering from "../common/LpOrdering";
  import pageLengthStructure from './pageLengthStructure'
  import ScrollTableWrapper from "../common/ScrollTableWrapper";

  export default {
    /*
    * nextPageName : 수정페이지로 랜딩시 필요없음, 단 board/1/post 와 같은 경우에만 사용 (현재 게시판 페이지에만 사용중)
    *
    *
    * */
    props:['field_list', 'items', 'filtered', 'title', 'table_width', 'filteredCount'],
    components: {ScrollTableWrapper, LpOrdering},
    data(){
      return {
        pageLengthList: pageLengthStructure.common,
        page_length:10,
        pagination: true,
        block: 1,
        start: 1,
        end: 10,
        check: false,
        enableDragScroll: false
      }
    },
    watch: {
      filtered: {
        handler(val) {
          if(this.filtered.page_num===1) {
            this.start = 1;
            this.block = 1;
          }
          if(this.start + 9 >= this.filtered.total_page) {
            this.end = this.filtered.total_page;
          }
          else if(this.block===1) {
            this.end = 10;
          }
        },
        deep: true
      },
      'filtered.total_page'(n) {
        //console.log(n)
        // if(this.filtered.total_page<10) this.end = this.filtered.total_page;
        if(this.start + 9 >= this.filtered.total_page) {
          this.end = this.filtered.total_page;
        }
      }
    },
    computed: {
      tableStyle(){
        if(this.table_width){
          return 'min-width:' + this.table_width + 'px';
        }
        else {
          return 'min-width: 1400px';
        }
      },
      calcPageList() {
        let page_list = [];
        for(let i=this.start; i<=this.end; i++) {
          page_list.push(i);
        }
        return page_list;
      }
    },
    methods:{
      openModalFile(type, item, file_type) {
        let value = {
          file: item[type],
          file_type: file_type
        }

        this.$store.commit('openModal', {type: 'modal-file-detail', value: value});
      },
      selPageLength() {
        this.$emit('selPageLength',this.page_length);
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.filtered.cur_page = num;
        this.$emit('getData');
      },
      prevPage() {
        if (this.filtered.page_num - 10 >= 1) {
          this.block -= 1;
          this.start = (this.block-1)*10+1;
          this.end = this.start + 9;
          this.filtered.page_num = this.start;
          this.filtered.cur_page = this.start;
          this.$emit('getData');
        }
      },
      nextPage() {
        if (this.filtered.page_num + 10 <= this.filtered.total_page) {
          this.block += 1;
          this.start = (this.block-1)*10+1;
          if(this.start + 9 >= this.filtered.total_page) {
            this.end = this.filtered.total_page;
          }
          else {
            this.end = this.start + 9;
          }
          this.filtered.page_num = this.start;
          this.filtered.cur_page = this.start;
          this.$emit('getData');
        }
        else {
          let next_block = this.block+1;
          if ((next_block - 1) * 10 + 1 <= this.filtered.total_page) {
            this.block += 1;
            this.start = (this.block - 1) * 10 + 1;
            this.end = this.filtered.total_page;
            this.filtered.page_num = this.start;
            this.filtered.cur_page = this.start;
            this.$emit('getData');
          }
        }
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      // 등급 승인요청, 완료 목록시 컨텐츠 체크
      checkContent(type, item) {
        //console.log(type, item)
        let imgExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'tiff', 'tif'];
        let fileExt = ['pdf', 'hwp', 'doc', 'ppt'];
        if (Array.isArray(item[type])){
          if(item[type].length>0){
            let ext = item[type][0].split('.')
            ext = ext[ext.length-1].toLowerCase();
            if (imgExt.includes(ext)) {
              return 'img';
            }
            else if (fileExt.includes(ext)) {
              return 'file';
            }
          }
          else return '';
        }
        else {
          return 'text';
        }
      },
      labelStyle(type, item){
        // 테두리 + 텍스트
        if( type === 0 ){
          return 'border: 1px solid;'
            + 'border-radius: 16px;'
            + 'padding: 2px 8px;'
            + this.labelBorderText(item);
        }
        // 텍스트
        else if( type === 1 ){
          return 'padding: 2px 8px;'
            + this.labelBorderText(item);
        }
        // 아이콘 + 텍스트
        else if( type === 2 ){
          return 'padding: 2px 8px;'
            + this.labelBorderText(item);
        }
        // 둥근라벨 + 텍스트
        else if( type === 3 ){
          return 'border: 1px solid;'
            + 'padding: 2px 8px;'
            + 'border-radius: 6px;'
            + 'background-color: rgba('
            + item.color.border.r + ','
            + item.color.border.g + ','
            + item.color.border.b + ','
            + item.color.border.a + ');'
            + this.labelBorderText(item);
        }
        //사각라벨 + 텍스트
        else if( type === 4 ){
          return 'border: 1px solid;'
            + 'padding: 2px 8px;'
            + 'background-color: rgba('
            + item.color.border.r + ','
            + item.color.border.g + ','
            + item.color.border.b + ','
            + item.color.border.a + ');'
            + this.labelBorderText(item);
        }
      },
      labelBorderText(item){
        return 'borderColor: rgba('
          + item.color.border.r + ','
          + item.color.border.g + ','
          + item.color.border.b + ','
          + item.color.border.a + ');'
          + 'color: rgba('
          + item.color.color.r + ','
          + item.color.color.g + ','
          + item.color.color.b + ','
          + item.color.color.a + ');';
      }
    }
  }
</script>

<style lang="scss">
  .table td, .table th {
    vertical-align: middle;
  }

  .pagination-group {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .pagination-btn-prev
  .pagination-btn-next {
    display: inline-block;
    height: 25px;
  }

  .pagination-num {
    display: inline-block;
  }

  .pagination-btn-prev i
  .pagination-btn-next i {
    color: #18a4ed;
    margin: 4px;
    cursor: pointer;
  }

  .pagination-num {
    padding: 5px 8px;
    cursor: pointer;
    font-size: .9rem;
  }

  .pagination-num-selected {
    color: #18a4ed;
  }

  .pagination-num-not-selected {
    color: #666;
  }

  // 테이블 상태 관련 버튼
  .state-btn {
    width: 100px;
  }

  .ests-btn-confirm-new {     // 신규요청확인
    background-color: #ffb100;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .ests-btn-request-sheet {     // 견적서 의뢰
    color: #fff;
    background-color: #5cb85c;
    cursor: pointer;
    border: none;
  }

  .ests-btn-write-sheet {    // 견적서 작성
    background-color: #008fd9;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .ests-btn-accept-order {    // 주문 승인
    background-color: #ffb100;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .ests-btn-deny-order {    // 주문 거절
    background-color: #db2828;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .btn-make-comment {    // 상품후기 답변 달기
    background-color: #ebab39;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .btn-edit-comment {    // 상품후기 답변 수정
    background-color: #064160;
    color: #fff;
    cursor: pointer;
    border: none;
  }


</style>
